import createClient from '../../apolloClient';
import QUERY_USER from '../../query/user';

const fetchUser = async (variables) => {
  const client = createClient();
  const result = await client.query({
    query: QUERY_USER,
    variables,
  });
  const { user } = result?.data || {};
  if (!user?.isSuccess) throw user.message;
  return user.user;
};

export default fetchUser;
